// src/pages/Documentation/docMap.js
export const documentationStructure = [
  // Standalone links
  {
    type: 'link',
    id: 'getting-started',
    title: 'Getting Started',
    path: '/docs/getting-started.md',
  },
  {
    type: 'link',
    id: 'agent-graph',
    title: 'Agents',
    path: '/docs/agent.md',
  },
  {
    type: 'link',
    id: 'programs',
    title: 'Programs',
    path: '/docs/programs.md',
  },
  {
    type: 'link',
    id: 'environments',
    title: 'Environments',
    path: '/docs/environments.md',
  },
  {
    type: 'link',
    id: 'spaces',
    title: 'Spaces',
    path: '/docs/spaces.md',
  },
  // Divider
  {
    type: 'divider',
    id: 'divider-node-types',
    title: 'Node Types',
  },
  // Basic Nodes group
  {
    type: 'group',
    id: 'basic-nodes',
    title: 'Basic Nodes',
    sections: [
      {
        id: 'node-start',
        title: 'Start',
        path: '/docs/nodes/basic-nodes/start.md',
      },
      {
        id: 'node-text',
        title: 'Text',
        path: '/docs/nodes/basic-nodes/text-node.md',
      },
      {
        id: 'node-variable',
        title: 'Variable',
        path: '/docs/nodes/basic-nodes/variable-node.md',
      },
      {
        id: 'node-end',
        title: 'End',
        path: '/docs/nodes/basic-nodes/end.md',
      },
      {
        id: 'node-blank',
        title: 'Blank',
        path: '/docs/nodes/basic-nodes/blank.md',
      },
      {
        id: 'node-comment',
        title: 'Comment',
        path: '/docs/nodes/basic-nodes/comment.md',
      },
      {
        id: 'static-text',
        title: 'Static Text',
        path: '/docs/nodes/basic-nodes/static-text.md',
      },
    ],
  },
  {
    type: 'group',
    id: 'user-nodes',
    title: 'User Nodes',
    sections: [
      {
        id: 'user-node',
        title: 'User Text & Files',
        path: '/docs/nodes/user-nodes/user-input.md',
      },
      {
        id: 'user-form',
        title: 'User Form',
        path: '/docs/nodes/user-nodes/user-form.md',
      },
      {
        id: 'user-program',
        title: 'User Program',
        path: '/docs/nodes/user-nodes/user-program.md',
      },
    ],
  },
  {
    type: 'group',
    id: 'decision-nodes',
    title: 'Decision Nodes',
    sections: [
      {
        id: 'static-decision-node',
        title: 'Static Decision',
        path: '/docs/nodes/decision/static-decision.md',
      },
      {
        id: 'code-node',
        title: 'Code',
        path: '/docs/nodes/decision/code-node.md',
      },
      {
        id: 'if-node',
        title: 'If',
        path: '/docs/nodes/decision/if-node.md',
      },
      {
        id: 'decision-node',
        title: 'Decision',
        path: '/docs/nodes/decision/decision.md',
      },
    ],
  },
  {
    type: 'group',
    id: 'merge-nodes',
    title: 'Merge Nodes',
    sections: [
      {
        id: 'static-merge-node',
        title: 'Static Merge',
        path: '/docs/nodes/merge/static-merge.md',
      },
      {
        id: 'view-meta-data.md',
        title: 'View Meta-Data',
        path: '/docs/nodes/merge/view-meta-data.md',
      },
      {
        id: 'merge-node',
        title: 'Merge',
        path: '/docs/nodes/merge/merge.md',
      },
    ],
  },
  {
    type: 'group',
    id: 'llm-nodes',
    title: 'LLM Nodes',
    sections: [
      {
        id: 'llm-basics',
        title: 'Basics',
        path: '/docs/nodes/llm/basics.md',
      },
      {
        id: 'reasoning-node',
        title: 'Reasoning',
        path: '/docs/nodes/llm/reasoning.md',
      },
      {
        id: 'instruction-node',
        title: 'Instruction',
        path: '/docs/nodes/llm/instruction.md',
      },
      {
        id: 'instruction-form',
        title: 'Instruction Form',
        path: '/docs/nodes/llm/instruction-form.md',
      },
      {
        id: 'instruction-program',
        title: 'Instruction Program',
        path: '/docs/nodes/llm/instruction-program.md',
      },
      {
        id: 'instruction-program-parameters',
        title: 'Instruction Program Parameters',
        path: '/docs/nodes/llm/instruction-program-parameters.md',
      },
    ],
  },
  {
    type: 'group',
    id: 'agent-and-program-noodes',
    title: 'Agent & Program Nodes',
    sections: [
      {
        id: 'agent-node',
        title: 'Sub-Agent',
        path: '/docs/nodes/agent/sub-agent.md',
      },
      {
        id: 'program-runner-node',
        title: 'Program Runner',
        path: '/docs/nodes/agent/program-runner.md',
      },
    ],
  },
  {
    type: 'group',
    id: 'memory-nodes',
    title: 'Memory Nodes',
    sections: [
      {
        id: 'flow-memory-node',
        title: 'Flow Memory Node',
        path: '/docs/nodes/memory/flow-memory-node.md',
        sections: [],
      },
      {
        id: 'read-node',
        title: 'Read Node',
        path: '/docs/nodes/memory/read-node.md',
      },
      {
        id: 'user-memory-node',
        title: 'User Memory Node',
        path: '/docs/nodes/memory/user-memory-node.md',
        sections: [],
      },
      {
        id: 'write-node',
        title: 'Write Node',
        path: '/docs/nodes/memory/write-node.md',
      },
    ],
  },

  // Divider
  {
    type: 'divider',
    id: 'programs-divider',
    title: 'Programs',
  },
  {
    type: 'group',
    id: 'Internal-Programs',
    title: 'Internal Programs',
    sections: [
      {
        id: 'View-File',
        title: 'View File',
        path: '/docs/Programs/InternalPrograms/View-File.md',
      },
      {
        id: 'View-Folder',
        title: 'View Folder',
        path: '/docs/Programs/InternalPrograms/View-Folder.md',
      },
      {
        id: 'Create-Folder',
        title: 'Create Folder',
        path: '/docs/Programs/InternalPrograms/Create-Folder.md',
      },
      {
        id: 'Create-File',
        title: 'Create File',
        path: '/docs/Programs/InternalPrograms/Create-File.md',
      },
      {
        id: 'Move-File',
        title: 'Move File',
        path: '/docs/Programs/InternalPrograms/Move-File.md',
      },
      {
        id: 'Add-Content-to-File',
        title: 'Add Content to File',
        path: '/docs/Programs/InternalPrograms/Add-Content-to-File.md',
      },
      {
        id: 'Update-File-Content',
        title: 'Update File Content',
        path: '/docs/Programs/InternalPrograms/Update-File-Content.md',
      },
      {
        id: 'Delete-Lines-From-File',
        title: 'Delete Lines From File',
        path: '/docs/Programs/InternalPrograms/Delete-Lines-From-File.md',
      },
      {
        id: 'Replace-Text-in-File',
        title: 'Replace Text in File',
        path: '/docs/Programs/InternalPrograms/Replace-Text-in-File.md',
      },
      {
        id: 'View-Environment',
        title: 'View Environment',
        path: '/docs/Programs/InternalPrograms/View-Environment.md',
      },
      {
        id: 'Create-Environment',
        title: 'Create Environment',
        path: '/docs/Programs/InternalPrograms/Create-Environment.md',
      },
      {
        id: 'Select-Environment',
        title: 'Select Environment',
        path: '/docs/Programs/InternalPrograms/Select-Environment.md',
      },
    ],
  },
  {
    type: 'group',
    id: 'Local-Programs',
    title: 'Local Programs',
    sections: [
      // Git subgroup
      {
        type: 'group',
        id: 'git-programs',
        title: 'Git',
        sections: [
          {
            id: 'GitStatus',
            title: 'Git Status',
            path: '/docs/Programs/LocalPrograms/Git/GitStatus.md',
          },
          {
            id: 'GitAdd',
            title: 'Git Add',
            path: '/docs/Programs/LocalPrograms/Git/GitAdd.md',
          },
          {
            id: 'GitCommit',
            title: 'Git Commit',
            path: '/docs/Programs/LocalPrograms/Git/GitCommit.md',
          },
          {
            id: 'GitPush',
            title: 'Git Push',
            path: '/docs/Programs/LocalPrograms/Git/GitPush.md',
          },
          {
            id: 'GitPull',
            title: 'Git Pull',
            path: '/docs/Programs/LocalPrograms/Git/GitPull.md',
          },
          {
            id: 'GitBranchManagement',
            title: 'Git Branch Management',
            path: '/docs/Programs/LocalPrograms/Git/GitBranchManagment.md',
          },
        ],
      },
      // Node.js subgroup
      {
        type: 'group',
        id: 'node-programs',
        title: 'Node.js',
        sections: [
          {
            id: 'NodeExecute',
            title: 'Node.js Execute',
            path: '/docs/Programs/LocalPrograms/Node/NodeExecute.md',
          },
          {
            id: 'NodeVersion',
            title: 'Node.js Version',
            path: '/docs/Programs/LocalPrograms/Node/NodeVersion.md',
          },
        ],
      },
      // Python subgroup
      {
        type: 'group',
        id: 'python-programs',
        title: 'Python',
        sections: [
          {
            id: 'Python-Execute',
            title: 'Python Execute',
            path: '/docs/Programs/LocalPrograms/Python/Python-Execute.md',
          },
          {
            id: 'Python-Version',
            title: 'Python Version',
            path: '/docs/Programs/LocalPrograms/Python/Python-Version.md',
          },
          {
            id: 'Create-Python-Virtual-Environment',
            title: 'Create Python Virtual Environment',
            path: '/docs/Programs/LocalPrograms/Python/Create-Python-Virtual-Environment.md',
          },
          {
            id: 'Activate-Python-Virtual-Environment',
            title: 'Activate Python Virtual Environment',
            path: '/docs/Programs/LocalPrograms/Python/Activate-Python-Virtual-Environment.md',
          },
          {
            id: 'Deactivate-Python-Virtual-Environment',
            title: 'Deactivate Python Virtual Environment',
            path: '/docs/Programs/LocalPrograms/Python/Deactivate-Python-Virtual-Environment.md',
          },
          {
            id: 'List-Python-Virtual-Environments',
            title: 'List Python Virtual Environments',
            path: '/docs/Programs/LocalPrograms/Python/List-Python-Virtual-Environments.md',
          },
        ],
      },
      // NPM subgroup
      {
        type: 'group',
        id: 'npm-programs',
        title: 'NPM',
        sections: [
          {
            id: 'Npm-Istall',
            title: 'Npm Install',
            path: '/docs/Programs/LocalPrograms/Npm/Npm-Install.md',
          },
          {
            id: 'Npm-List-Packages',
            title: 'Npm List Packages',
            path: '/docs/Programs/LocalPrograms/Npm/Npm-List-Packages.md',
          },
          {
            id: 'Npm-Run-Script',
            title: 'Npm Run Script',
            path: '/docs/Programs/LocalPrograms/Npm/Npm-Run-Script.md',
          },
        ],
      },
      {
        type: 'group',
        id: 'Shell',
        title: 'Shell',
        sections: [
          {
            type: 'group',
            id: 'shell-navigation',
            title: 'Navigation',
            sections: [
              {
                id: 'print-working-directory',
                title: 'Print Working Directory',
                path: '/docs/Programs/LocalPrograms/Shell/Navigation/print-working-directory.md',
              },
              {
                id: 'change-directory',
                title: 'Change Directory',
                path: '/docs/Programs/LocalPrograms/Shell/Navigation/change-directory.md',
              },
              {
                id: 'list-directory',
                title: 'List Directory',
                path: '/docs/Programs/LocalPrograms/Shell/Navigation/list-directory.md',
              },
            ],
          },
          {
            type: 'group',
            id: 'shell-file-content',
            title: 'File Content',
            sections: [
              {
                id: 'display-file-contents',
                title: 'Display File Contents',
                path: '/docs/Programs/LocalPrograms/Shell/File-content/display-file-contents.md',
              },
              {
                id: 'head',
                title: 'Head',
                path: '/docs/Programs/LocalPrograms/Shell/File-content/head.md',
              },
              {
                id: 'tail',
                title: 'Tail',
                path: '/docs/Programs/LocalPrograms/Shell/File-content/tail.md',
              },
            ],
          },
          {
            type: 'group',
            id: 'shell-search',
            title: 'Search',
            sections: [
              {
                id: 'search-text-pattern',
                title: 'Search Text Pattern',
                path: '/docs/Programs/LocalPrograms/Shell/Search/search-text-pattern.md',
              },
              {
                id: 'find-files',
                title: 'Find Files',
                path: '/docs/Programs/LocalPrograms/Shell/Search/find-files.md',
              },
              {
                id: 'locate-command',
                title: 'Locate Command',
                path: '/docs/Programs/LocalPrograms/Shell/Search/locate-command.md',
              },
            ],
          },
          {
            type: 'group',
            id: 'shell-file-operations',
            title: 'File Operations',
            sections: [
              {
                id: 'copy-files',
                title: 'Copy Files',
                path: '/docs/Programs/LocalPrograms/Shell/File-operations/copy-files.md',
              },
              {
                id: 'move-files',
                title: 'Move Files',
                path: '/docs/Programs/LocalPrograms/Shell/File-operations/move-files.md',
              },
              {
                id: 'remove-files',
                title: 'Remove Files',
                path: '/docs/Programs/LocalPrograms/Shell/File-operations/remove-files.md',
              },
              {
                id: 'touch-files',
                title: 'Touch Files',
                path: '/docs/Programs/LocalPrograms/Shell/File-operations/touch-files.md',
              },
            ],
          },
          {
            type: 'group',
            id: 'shell-text-processing',
            title: 'Text Processing',
            sections: [
              {
                id: 'stream-editor',
                title: 'Stream Editor (sed)',
                path: '/docs/Programs/LocalPrograms/Shell/Text-processing/stream-editor.md',
              },
              {
                id: 'awk-text-processor',
                title: 'Awk Text Processor',
                path: '/docs/Programs/LocalPrograms/Shell/Text-processing/awk-text-processor.md',
              },
              {
                id: 'sort-text',
                title: 'Sort Text',
                path: '/docs/Programs/LocalPrograms/Shell/Text-processing/sort-text.md',
              },
              {
                id: 'unique-lines',
                title: 'Unique Lines',
                path: '/docs/Programs/LocalPrograms/Shell/Text-processing/unique-lines.md',
              },
              {
                id: 'word-count',
                title: 'Word Count',
                path: '/docs/Programs/LocalPrograms/Shell/Text-processing/word-count.md',
              },
              {
                id: 'cut',
                title: 'Cut',
                path: '/docs/Programs/LocalPrograms/Shell/Text-processing/cut.md',
              },
              {
                id: 'translate-characters',
                title: 'Translate Characters (tr)',
                path: '/docs/Programs/LocalPrograms/Shell/Text-processing/translate-characters.md',
              },
            ],
          },
          {
            type: 'group',
            id: 'shell-utilities',
            title: 'Utilities',
            sections: [
              {
                id: 'echo-text',
                title: 'Echo Text',
                path: '/docs/Programs/LocalPrograms/Shell/Utilities/echo-text.md',
              },
            ],
          },
        ],
      },
    ],
  }, // ✅ closes Local Programs group properly

  // ✅ Provider Programs now visible
  {
    type: 'group',
    id: 'Provider-Programs',
    title: 'Provider Programs',
    sections: [
      {
        id: 'Dalle',
        title: 'Dalle',
        path: '/docs/Programs/ProviderPrograms/Dalle.md',
      },
      {
        id: 'Luma-Dream-Machine',
        title: 'Luma Dream Machine',
        path: '/docs/Programs/ProviderPrograms/Luma-Dream-Machine.md',
      },
    ],
  },
];
